import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SocialIcons from './SocialIcons';
import logo from '../assets/images/logo_sindicato_metalurgicos_bauru_retangular_fundo_transparente.png';

function Footer() {
	const selectedPath = window.location.pathname;
	const isSpecificPage = ['/fim-da-escala-6x1'].includes(selectedPath);
	return (
		<>
		{!isSpecificPage && 
			<footer className="site-footer">
				<Container>
					<Row className="footer-main py-5">
						<Col xs={12} md={4} className="mb-4 mb-md-0">
							<img
								src={logo}
								width="140"
								alt="Logo do Sindicato dos Metalúrgicos de Bauru e Região"
								className="footer-logo"
							/>
							<p className="footer-desc">
								Defendendo os direitos dos trabalhadores metalúrgicos de Bauru e Região desde sempre.
							</p>
							<SocialIcons />
						</Col>
						<Col xs={12} md={4} className="mb-4 mb-md-0">
							<h6 className="footer-heading">Navegação</h6>
							<ul className="footer-links">
								<li><a href="/">Início</a></li>
								<li><a href="/noticias">Notícias</a></li>
								<li><a href="/jornal">Jornal</a></li>
								<li><a href="/beneficios">Benefícios</a></li>
								<li><a href="/associe-se">Associe-se</a></li>
								<li><a href="/contato">Contato</a></li>
							</ul>
						</Col>
						<Col xs={12} md={4}>
							<h6 className="footer-heading">Contato</h6>
							<address className="footer-contact">
								<p>Rua Araujo Leite, 2-25<br />Centro — Bauru/SP</p>
								<p><a href="tel:+551432324367">(14) 3232-4367</a></p>
								<p><a href="mailto:sindimetalurgicos@uol.com.br">sindimetalurgicos@uol.com.br</a></p>
							</address>
						</Col>
					</Row>
				</Container>
				<div className="footer-bottom">
					<Container>
						<p className="mb-0 text-center py-3">
							© {new Date().getFullYear()} Sindicato dos Metalúrgicos nas Indústrias Metalúrgicas Mecânicas e de Materiais Elétricos de Bauru e Região. Todos os direitos reservados.
						</p>
					</Container>
				</div>
			</footer>
		}
		</>
	);
}

export default Footer;